import { oldApiInstance } from 'functions/request';

export const fetchPromoStoreTagsApi = ({ ruleId, page, perPage }) => {
  return oldApiInstance.get(`shop/popular_rules/${ruleId}/on_sale?page=${page}&per_page=${perPage}`);
};
